// Third Party
import * as React from 'react';
import { useToggle } from '@hooks';

export function useModal() {
  const { on: modalActive, setOff: closeModal, setOn: openModal } = useToggle();

  // If modal is active add class to body to prevent scroll
  React.useEffect(() => {
    if (modalActive) {
      document.body.classList.add('modalActive');
    } else {
      document.body.classList.remove('modalActive');
    }
  }, [modalActive]);

  return { modalActive, closeModal, openModal };
}
